import Vue from 'vue';
import VueRouter from 'vue-router';
import homne from '../views/Home.vue';
import cl4 from '../views/Cl4.vue';
import black808 from '../views/Black808.vue';
import white808 from '../views/White808.vue';
import main from '../views/Main.vue';
import white808userinfo from '../views/White808UserInfo.vue'
import cl4userinfo from '../views/Cl4UserInfo.vue'
import login from '../views/login.vue'
import reguster from '../views/Reguster.vue'
import center from '../views/PersonCenter.vue'
import editPassword from '../views/EditPassword.vue'
import editPassword1 from '../views/EditPassword1.vue'
import cl4Face from '../views/Cl4Face.vue'
Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: login
    },
    {
        path:'/reguster',
        name:'Reguster',
        component: reguster
    },
    {
        path :'/editPassword',
        name :'EditPassword',
        component: editPassword
    },
    {
        path :'/editPassword1',
        name :'EditPassword1',
        component: editPassword1
    },
    {
        path: '/',
        component: main,
        redirect: '/home',
        children: [
            { path: '', redirect: '/login' }, // 默认重定向到登录页面
            { path: 'home', component: homne },
            { path: 'cl4', component: cl4 },
            { path: 'black808', component: black808 },
            { path: 'white808', component: white808 },
            { path: 'white808userinfo', component: white808userinfo },
            { path: 'cl4userinfo', component: cl4userinfo },
            { path: 'center',component:center},
            { path: 'cl4Face',component:cl4Face}
        ]
    },

];
const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
});

export default router;